import { useEffect } from "react";

export default function JsonLd({ schema, testid = "json-ld" }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-testid", testid);
    script.textContent = JSON.stringify({ "@context": "https://schema.org", ...schema });
    document.head.appendChild(script);
    return () => script.remove();
  }, [schema]);
  return null;
}
